import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub, FaHackerrank } from 'react-icons/fa';
import {SiLeetcode} from 'react-icons/si'
const HeaderSocials = () => {
  return (
    <div className="header__socials">
      <a href="https://www.linkedin.com/in/vishaaal/" target="_blank" rel="noreferrer" ><BsLinkedin /></a>
      <a href="https://github.com/vishaaal" target="_blank" rel="noreferrer" ><FaGithub /></a>
      <a href="https://www.hackerrank.com/vishaaal?hr_r=1" target="_blank" rel="noreferrer" ><FaHackerrank /></a>
      <a href="https://leetcode.com/vishaaal/" target="_blank" rel="noreferrer" ><SiLeetcode /></a>


    </div>
  )
}

export default HeaderSocials